(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var SECTION = '[data-section-type="product"]';
    var STICKY_SELECT = '[data-sticky-variant-input]';
    var MAIN_WRAP = '.product__variants-wrapper';

    // El <select name="options[...]"> es la unica ancla siempre presente:
    // tiene data-index="optionN" sin importar el estilo (swatch/chip/dropdown) ni
    // si enable_dynamic_product_options esta activo. Las clases dynamic-variant-* son
    // condicionales, por eso NO dependemos de ellas.
    function mainSelectFor(section, optionIndex) {
      var wrap = section.querySelector(MAIN_WRAP);
      if (!wrap) return null;
      return wrap.querySelector('select[name^="options"][data-index="' + optionIndex + '"]');
    }

    // Sticky select -> selector principal (que dispara todo el pipeline del tema)
    function driveMain(section, stickySelect) {
      var optionIndex = stickySelect.dataset.optionIndex;
      var value = stickySelect.value;
      var chosen = stickySelect.options[stickySelect.selectedIndex];
      var handle = chosen ? chosen.getAttribute('data-value-handle') : '';
      var select = mainSelectFor(section, optionIndex);
      if (!select) return;

      // Estilo swatch / chip: los botones son hermanos del <select> (mismo parent).
      // Replicamos el click nativo: el handler del tema togglea la clase .selected,
      // marca la <option> y dispara el change. Asi el picker de la seccion cambia
      // tambien VISUALMENTE, no solo la variante. El handle incluye el sufijo
      // "--<index>" para coincidir con data-option-handle del boton.
      var button = handle
        ? select.parentElement.querySelector('[data-button][data-option-handle="' + handle + '"]')
        : null;
      if (button) {
        button.click();
        return;
      }

      // Estilo dropdown nativo (no hay botones en el grupo)
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change'));
      }
    }

    // Selector principal -> sticky selects (cuando el usuario usa el selector de la PDP)
    function syncStickyFromMain(section) {
      var stickySelects = section.querySelectorAll(STICKY_SELECT);
      for (var i = 0; i < stickySelects.length; i++) {
        var s = stickySelects[i];
        var select = mainSelectFor(section, s.dataset.optionIndex);
        if (select && select.value && s.value !== select.value) {
          s.value = select.value;
        }
      }
    }

    function init(section) {
      if (!section || section.dataset.stickyVariantBound === 'true') return;
      var stickySelects = section.querySelectorAll(STICKY_SELECT);
      if (!stickySelects.length) return;
      section.dataset.stickyVariantBound = 'true';

      stickySelects.forEach(function (s) {
        s.addEventListener('change', function () {
          driveMain(section, s);
        });
      });

      var mainSelects = section.querySelectorAll(MAIN_WRAP + ' select[name^="options"]');
      mainSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          syncStickyFromMain(section);
        });
      });
    }

    function initAll(root) {
      (root || document).querySelectorAll(SECTION).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    // Theme editor: re-inicializa cuando la seccion del producto se recarga
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
